export const state = {
    selections: [],
    selectionsObjectData: [],
    pointer: null,
    pointerFocus: undefined,
    markingSelectionArea: false,
    selectedGroupIndex: 0,
    selectedItemIndex: 0,
    selectionCancelTokens: [],
    layerSelection: true,
    locationSelection: false,
    residentSelection: false,
    companySelection: false,
    addressAtPoint: {
        point: null,
        addressData: null,
        geocodeAddress: null,
        geocodeParcel: null,
        address: null,
        parcelGeometry: null,
        parcelIdentificationLocalID: null,
        parcelTitle: null
    },
    autoOpenRelations: false
};

export default state;
